import { render, staticRenderFns } from "./BaseErrorIcon.vue?vue&type=template&id=6b3d0479&scoped=true&"
import script from "./BaseErrorIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseErrorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseErrorIcon.vue?vue&type=style&index=0&id=6b3d0479&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d0479",
  null
  
)

export default component.exports